export class DefaultTemplatePeriodTask {
	public index;

	constructor(obj) {
		this.index = obj.index;
	}
} 
